export const breakpoints = {
  base: '320px',
  xs: '360px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1200px',
  xxl: '1366px',
  xxxl: '1440px',
};

export const device = {
  base: `only screen and (max-width: ${breakpoints.base})`, //320px
  mobile: `only screen and (max-width: ${breakpoints.xs})`, //360px
  tabletS: `only screen and (max-width: ${breakpoints.sm})`, //640px
  tabletB: `only screen and (max-width: ${breakpoints.md})`, //768px
  desktopS: `only screen and (max-width: ${breakpoints.lg})`, //1024px
  desktopM: `only screen and (max-width: ${breakpoints.xl})`, //1200px
  desktopB: `only screen and (max-width: ${breakpoints.xxl})`, //1366px
  desktopC: `only screen and (max-width: ${breakpoints.xxxl})`, //1440px
  xs: `only screen and (min-width: ${breakpoints.xs})`, //360px
  sm: `only screen and (min-width: ${breakpoints.sm})`, //640px
  md: `only screen and (min-width: ${breakpoints.md})`, //768px
  lg: `only screen and (min-width: ${breakpoints.lg})`, //1024px
  xl: `only screen and (min-width: ${breakpoints.xl})`, //1280px
  xxl: `only screen and (min-width: ${breakpoints.xxl})`, //1366px
  xxxl: `only screen and (min-width: ${breakpoints.xxxl})`, //1440px
};

export const media = {
  mobile: (styles: any) => `
    @media ${device?.mobile} {
      ${styles}
    }
  `,
  tabletS: (styles: any) => `
    @media ${device?.tabletS} {
      ${styles}
    }
  `,
  tabletB: (styles: any) => `
    @media ${device?.tabletB} {
      ${styles}
    }
  `,
  desktopS: (styles: any) => `
    @media ${device?.desktopS} {
      ${styles}
    }
  `,
  desktopM: (styles: any) => `
    @media ${device?.desktopM} {
      ${styles}
    }
  `,
  desktopB: (styles: any) => `
    @media ${device?.desktopB} {
      ${styles}
    }
  `,
  desktopC: (styles: any) => `
    @media ${device?.desktopC} {
      ${styles}
    }
  `,
};
